import UserProfile from "./UserProfile";
import { UserRoles } from "./enums";

export class UserUtils {
  /** Azure AD display name. Must match groups_ad.display_name. */
  static readonly FINANCE_ADMINS_GROUP = "Finance Admins";

  /** XGS administrators, or XGS users in the Finance Admins AD group. */
  static canAccessFinancePayments = (user?: UserProfile | null): boolean => {
    if (!user) return false;
    if (UserUtils.isXGSAdministrator(user)) return true;
    return !!UserUtils.isXGSUser(user) && UserUtils.hasAssignedGroup(user, UserUtils.FINANCE_ADMINS_GROUP);
  };

  // customers
  static isUser = (user?: UserProfile | null) => {
    if (user && user.role) {
      return user.role === UserRoles.USER;
    }
  };

  static isAdministrator = (user?: UserProfile | null) => {
    if (user && user.role) {
      return user.role === UserRoles.ADMINISTRATOR;
    }
  };

  static isCustomer = (user?: UserProfile | null) => {
    if (user && user.role) {
      return (user.role === UserRoles.USER) || (user.role === UserRoles.ADMINISTRATOR);
    }
  };

  // employees
  static isXGSUser = (user?: UserProfile | null) => {
    if (user && user.role) {
      return user.role === UserRoles.XGS_USER;
    }
  };

  static isXGSAdministrator = (user?: UserProfile | null) => {
    if (user && user.role) {
      return user.role === UserRoles.XGS_ADMINISTRATOR;
    }
  };

  static isEmployee = (user?: UserProfile | null) => {
    if (user && user.role) {
      return (user.role === UserRoles.XGS_USER) || (user.role === UserRoles.XGS_ADMINISTRATOR);
    }
  };

  static isXGSDriver = (user?: UserProfile | null) => {
    if (user && user.role) {
      return user.role === UserRoles.XGS_DRIVER;
    }
  };

  static isAgent = (user?: UserProfile | null) => {
    if (user && user.role) {
      return user.role === UserRoles.AGENT
    }
  }

  static isSSO = (user?: UserProfile | null) => {
    if (user) {
      return user.sso;
    }
  }

  static hasPermission = (
    user: UserProfile | null,
    accountId: string | null,
    permission: string
  ): boolean => {
    if (user && user.role) {
      if ((user.role === UserRoles.ADMINISTRATOR && accountId) || user.role === UserRoles.XGS_USER || user.role === UserRoles.XGS_ADMINISTRATOR) return true;
      if (!accountId) return false;
      let currentAccount = user.subAccounts.find(account => account.id === accountId);
      if (!currentAccount) return false;
      return !!currentAccount.permissions.find(permissionsItem => permissionsItem === permission);
    } else {
      return false;
    }
  };

  static hasFeatureDisabled = (
    user: UserProfile | null | undefined,
    feature: string
  ): boolean => {
    if (user && user.disabledFeatures) {
      return !!user.disabledFeatures.find(disabledFeature => disabledFeature === feature);
    } else {
      return false;
    }
  };

  static hasAssignedGroup = (
    user: UserProfile | null | undefined,
    groupName: string
  ): boolean => {
    if (!user?.assignedGroups) return false;
    const groups = user.assignedGroups;
    if (typeof groups === "string") {
      return groups === groupName || groups.split(",").map((g) => g.trim()).includes(groupName);
    }
    if (Array.isArray(groups)) {
      return groups.some((g) => g === groupName);
    }
    return false;
  };
}
